<template>
  <div class="flex w-full flex-col">
    <div class="flex w-full justify-center items-center">
      <h3>Gracias por su donación</h3>
    </div>
    <div class="flex w-full p-8">
      <vs-spacer/>
      <div class="w-9/12">
        <div class="w-full mb-8">
          Seleccione el proyecto al cual desea donar
          <v-select v-model="selectedEvent" :options="donationEvents" label="name" :clearable="false"></v-select>
        </div>
        <div class="w-full mb-8">
          <vs-input class="w-full" label-placeholder="Nombre" v-model="name"/>
        </div>
        <div class="w-full mb-8">
          <vs-input
            class="w-full"
            label-placeholder="Dirección de correo electrónico"
            v-model="email"
            :danger="!validEmail"
            danger-text="Debe especificar una dirección de correo electrónico"
          />
        </div>
        <div class="w-full mb-8">
          <vs-input class="w-full" label-placeholder="Número de teléfono" v-model="phone" v-mask="['#### ####']"/>
        </div>
        <div class="w-full mb-8">
          <vs-input
            class="w-full"
            label-placeholder="Valor a donar (Quetzales)"
            v-model="amount"
            type="number"
            :danger="!validAmount"
            danger-text="Debe especificar un valor a donar"
          />
        </div>
        <div class="w-full mb-8">
          <vs-input
            class="w-full"
            label-placeholder="Número de tarjeta"
            v-model="cardNumber"
            v-mask="['#### #### #### ####']"
            :danger="!validCardNumber"
            danger-text="Debe indicar número de tarjeta"
          />
        </div>
        <div class="w-full mb-8">
          <vs-input
            class="w-full"
            label-placeholder="Nombre en la tarjeta"
            v-model="cardName"
            :danger="!validCardName"
            danger-text="Debe indicar nombre en la tarjeta"
          />
        </div>
        <div class="flex w-full flex-row mb-8">
          <vs-select class="w-32 mr-2" label="Mes vencimiento" v-model="cardExpireMonth">
            <vs-select-item v-for="item in months" :key="item.value" :text="`${item.value}`" :value="item.value"/>
          </vs-select>
          <vs-select class="w-32 mr-2" label="Año vencimiento" v-model="cardExpireYear">
            <vs-select-item v-for="item in years" :key="item.value" :text="`${item.value}`" :value="item.value"/>
          </vs-select>
          <vs-input
            label="CVV"
            type="number"
            v-model="cvv"
            class="ml-4 w-24"
            :danger="!validCVV"
            danger-text="Debe indicar CVV de la tarjeta"
          />
        </div>
        <div class="w-full mb-8">
          <vs-button icon-pack="feather" icon="icon-gift" @click="placeDonation">DONAR</vs-button>
        </div>
      </div>
      <vs-spacer/>
    </div>
  </div>

</template>

<script>
  import vSelect from 'vue-select';
  import {mask} from 'vue-the-mask';

  export default {
    name: "Donate",
    directives: {mask},
    data() {
      return {
        selectedEvent: {id: 0, name: ''},
        name: '',
        email: '',
        phone: '',
        amount: 0,
        cardNumber: '',
        cardName: '',
        cardExpireMonth: ('0' + (new Date().getMonth() + 1)).slice(-2),
        cardExpireYear: new Date().getFullYear(),
        cvv: '',
        validCard: false
      }
    },
    components: {
      'v-select': vSelect,
    },
    computed: {
      windowWidth() {
        return this.$store.state.windowWidth;
      },
      validateCardAPI() {
        return this.$store.getters['getParameter']('orders').validateCardAPI;
      },
      donationEvents() {
        if (this.$store.state.donationEvents) {
          if (this.$store.state.donationEvents.list) {
            return this.$store.state.donationEvents.list.filter(item => (item.status == 'ACT'));
          } else {
            return [];
          }
        } else {
          return [];
        }
      },
      months() {
        return [
          {value: '01'},
          {value: '02'},
          {value: '03'},
          {value: '04'},
          {value: '05'},
          {value: '06'},
          {value: '07'},
          {value: '08'},
          {value: '09'},
          {value: '10'},
          {value: '11'},
          {value: '12'},
        ];
      },
      years() {
        return this.getYears();
      },
      validEmail() {
        return this.email != '';
      },
      validAmount() {
        return this.amount > 0;
      },
      validCardNumber() {
        return this.cardNumber != '';
      },
      validCardName() {
        return this.cardName != '';
      },
      validCVV() {
        return this.cvv != '';
      }
    },
    methods: {
      getYears() {
        let years = [];
        let year = new Date().getFullYear();
        for (var i = 0; i < 10; i++) {
          years.push({value: year.toString()});
          year++;
        }
        return years;
      },
      placeDonation() {
        if (this.selectedEvent.id <= 0) {
          this.$vs.notify({
            title: 'Error',
            text: 'Debe seleccionar un proyecto como destino para su donación',
            color: 'danger'
          });
        } else if (!this.validEmail) {
            this.$vs.notify({
              title: 'Error',
              text: 'Debe especificar una dirección de correo electrónico válida',
              color: 'danger'
            });
          } else if (!this.validAmount) {
          this.$vs.notify({
            title: 'Error',
            text: 'Debe indicar un monto a donar',
            color: 'danger'
          });
        } else if (!this.validCardNumber) {
          this.$vs.notify({
            title: 'Error',
            text: 'Debe especificar número de tarjeta',
            color: 'danger'
          });
        } else if (!this.validCardNumber) {
          this.$vs.notify({
            title: 'Error',
            text: 'Debe especificar número de tarjeta',
            color: 'danger'
          });
        } else if (!this.validCardName) {
          this.$vs.notify({
            title: 'Error',
            text: 'Debe especificar nombre en la tarjeta',
            color: 'danger'
          });
        } else {
          const self = this;
          this.$vs.loading({
            text: 'Autorizando cargo a tarjeta, espere por favor',
            type: 'point'
          });
          this.$http.post(this.validateCardAPI, {
            amount: this.amount,
            name: this.cardName,
            email: this.email,
            phone: this.phone,
            address: 'Guatemala',
            city: 'Guatemala',
            cardNumber: this.cardNumber,
            cardExpireMonth: this.cardExpireMonth,
            cardExpireYear: this.cardExpireYear,
            cvv: this.cvv,
            uuid: window.uuidv4
          }).then(response => {
            self.$vs.loading.close();
            let authorized = false;
            if (response.data) {
              if (response.data.text) {
                const data = JSON.parse(response.data.text);
                if (data) {
                  if (data.status) {
                    if (data.status == 'AUTHORIZED') {
                      authorized = true;
                      self.insertOrder();
                    }
                  }
                }
              }
            }
            if (!authorized) {
              self.$vs.notify({
                title: 'Validación de tarjeta',
                text: 'El cargo a la tarjeta no fue autorizado',
                color: 'danger'
              });
            }
          }).catch(error => {
            self.$vs.loading.close();
            var errorMessage = '';
            if (error.message) {
              errorMessage = error.message;
            } else {
              errorMessage = 'Error de conectividad al autorizar tarjeta'
            }
            console.log(errorMessage);
            self.$vs.notify({
              title: 'Validación de tarjeta',
              text: 'El cargo a la tarjeta no fue autorizado',
              color: 'danger'
            });
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
